import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../error_boundary";
import GetQwotedCTA from "../profiles/GetQwotedCTA";
import PrProfile from "./PrProfile";
import { PrProfileProvider } from "./data/pr_profile_context_management";

// Registered entry point for the PR profile show page (mirrors CompanyTopLevelShow): wraps the
// provider + error boundary around the show. The ERB mounts this component by name.
function PrProfileTopLevelShow({ prProfileId, viewerContext = undefined }) {
  const contextValue = { viewerContext };

  return (
    <PrProfileProvider value={contextValue}>
      <ErrorBoundary>
        <PrProfile prProfileId={prProfileId} />
      </ErrorBoundary>
      {!viewerContext?.isAuthenticated && <GetQwotedCTA />}
    </PrProfileProvider>
  );
}

PrProfileTopLevelShow.propTypes = {
  prProfileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  viewerContext: PropTypes.shape({
    editable: PropTypes.bool,
    isSelf: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    planPaid: PropTypes.bool,
    role: PropTypes.string,
  }),
};

export default PrProfileTopLevelShow;
